import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { ExtraPanelTabButton } from './components/TabButton.js';
import { IconAssistantTab, IconInfoTabItem } from '@fabric-app/icons/old';
import { useQueryComments } from '../../../../comments/queries/useQueryComments.js';
import { useExpandedFdocContext } from '../../ExpandedFdoc/ExpandedFdocProvider.js';
import { ExtraPanelTabComments } from './Comments/ExtraPanelTabComments.js';
import { ExpandedFdocSidebar_SimilarContent } from '../../ExpandedFdoc/ExpandedFdocSidebar_SimilarContent.js';
import { ExtraPanelTabAssistant } from './Assistant/ExtraPanelTabAssistant.js';
import { ExtraPanelInfo } from './Info/ExtraPanelInfo.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { Flex } from '@fabric-app/ui/components/Flex';
import { ForcedTheme } from '@fabric-app/ui/theme/ForcedTheme';
import { SimilarIconFilled } from '@fabric-app/icons/icons';
import { useContextShareToken } from '../../../../permission/contexts/AnonShareTokenContext.js';
import { styled } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { usePostSigninRedirect } from '../../../../auth/hooks/usePostSigninRedirect.js';

const ExtraPanelContent = ({ isContentEnabled, resourceId, onTabItemSelect, inputsVisible }) => {
  const { selectedExtraPanel, setSelectedExtraPanel } = useExpandedFdocContext();
  const { isXSView, isXSSView } = useResponsive();
  const shareToken = useContextShareToken();
  const isPublished = shareToken?.type === "publishing";
  const { comments } = useQueryComments(resourceId, {
    enabled: isContentEnabled && !isPublished
  });
  const handleClickTabButton = (e) => {
    const nextTab = e.currentTarget.value;
    setSelectedExtraPanel(nextTab);
    onTabItemSelect?.();
  };
  const { redirectToSignin } = usePostSigninRedirect();
  return /* @__PURE__ */ jsxs(Flex, {
    direction: "column",
    style: {
      height: "100%",
      position: "relative"
    },
    children: [
      /* @__PURE__ */ jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        gap: isXSView || isXSSView ? "element" : "elementsContainer",
        style: {
          padding: ".75rem",
          flexShrink: 0,
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
        },
        flexGrow: 0,
        children: [
          !isPublished && /* @__PURE__ */ jsxs(Fragment, {
            children: [
              /* @__PURE__ */ jsxs(ExtraPanelTabButton, {
                variant: "comments",
                active: selectedExtraPanel === "comments",
                isFullscreen: false,
                tabIndex: 7,
                value: "comments",
                /**
                * Using onClick to make sure it does acts natively,
                * so if the user presses and then pans the resizable container it wont tigger the click event.
                */
                onClick: handleClickTabButton,
                children: [
                  "Comments ",
                  /* @__PURE__ */ jsx(ExtraPanelTabButton.Count, {
                    children: comments.length
                  })
                ]
              }),
              /* @__PURE__ */ jsxs(ExtraPanelTabButton, {
                variant: "similar",
                active: selectedExtraPanel === "similar",
                isFullscreen: false,
                tabIndex: 7,
                value: "similar",
                /**
                * Using onClick to make sure it does acts natively,
                * so if the user presses and then pans the resizable container it wont tigger the click event.
                */
                onClick: handleClickTabButton,
                children: [
                  /* @__PURE__ */ jsx(SimilarIconFilled, {
                    color: "#FFF"
                  }),
                  "Similar"
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsxs(ExtraPanelTabButton, {
            variant: "similar",
            active: selectedExtraPanel === "assistant",
            isFullscreen: false,
            tabIndex: 7,
            value: "assistant",
            /**
            * Using onClick to make sure it does acts natively,
            * so if the user presses and then pans the resizable container it wont tigger the click event.
            */
            onClick: handleClickTabButton,
            children: [
              /* @__PURE__ */ jsx(IconAssistantTab, {
                style: {
                  width: 20,
                  height: 20
                }
              }),
              "Ask"
            ]
          }),
          /* @__PURE__ */ jsx(ExtraPanelTabButton, {
            variant: "similar",
            active: selectedExtraPanel === "info",
            isFullscreen: false,
            tabIndex: 7,
            value: "info",
            onClick: handleClickTabButton,
            square: isXSSView,
            children: isXSSView ? /* @__PURE__ */ jsx(IconInfoTabItem, {
              style: {
                width: 16,
                height: 16
              }
            }) : "Info"
          }),
          isPublished && /* @__PURE__ */ jsx(CopyToFabricButton, {
            onClick: () => redirectToSignin(),
            children: "Copy to your Fabric"
          })
        ]
      }),
      isContentEnabled && (selectedExtraPanel === "comments" ? /* @__PURE__ */ jsx(Flex, {
        direction: "column",
        flexGrow: 1,
        style: {
          overflow: "hidden",
          position: "relative"
        },
        children: /* @__PURE__ */ jsx(ExtraPanelTabComments, {
          commentInputVisible: inputsVisible,
          resourceId
        })
      }) : selectedExtraPanel === "similar" ? /* @__PURE__ */ jsx(ExpandedFdocSidebar_SimilarContent, {
        /**
        * @TODO
        */
        hideSimilar: false,
        isFullscreen: false
      }) : selectedExtraPanel === "assistant" ? /* @__PURE__ */ jsx(ExtraPanelTabAssistant, {
        commentInputVisible: inputsVisible
      }) : selectedExtraPanel === "info" ? /* @__PURE__ */ jsx(ForcedTheme, {
        colorScheme: "dark",
        asChild: true,
        children: /* @__PURE__ */ jsx(ExtraPanelInfo, {})
      }) : null)
    ]
  });
};
const CopyToFabricButton = styled(ExtraPanelTabButton).withConfig({
  displayName: "ExtraPanelContent__CopyToFabricButton",
  componentId: "sc-c006ca75-0"
})([
  `color:`,
  `;background:#ebe5ff;`
], cssVar["color-app-primary"]);

export { ExtraPanelContent };
//# sourceMappingURL=ExtraPanelContent.js.map
